export default __webpack_public_path__ + "static/media/default.6eb7f5dbfb4cdb2628667228cda83a05.svg";